import { Link } from "react-router";
import { listTopics } from "../../../data/study/topics";

export function LerenIndexPage() {
  const topics = listTopics();

  return (
    <main className="flex-1 mx-auto w-full max-w-3xl lg:max-w-4xl px-5 sm:px-6 py-8 sm:py-12 space-y-8">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
      >
        <span aria-hidden>←</span>
        <span>Naar startpagina</span>
      </Link>
      <header className="space-y-3">
        <p className="text-xs uppercase tracking-wider text-[var(--ink-faint)] font-mono-badge">
          Leren
        </p>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">
          A2 grammar crash course
        </h1>
        <p className="font-serif-italic text-lg text-[var(--ink-muted)] max-w-prose">
          Short textbook chapters covering the topics DUO graders expect. No AI, no
          quizzes — just the rules and examples you need.
        </p>
      </header>

      <ul className="space-y-3">
        {topics.map((t) => (
          <li key={t.slug}>
            <Link
              to={`/leren/${t.slug}`}
              className="group block rounded-2xl border border-[var(--border)] bg-[var(--panel)] hover:border-[var(--accent)]/40 hover:bg-[var(--panel-soft)] transition-colors p-5 sm:p-6"
            >
              <div className="flex items-baseline justify-between gap-3 mb-1.5">
                <h2 className="text-xl sm:text-2xl font-semibold tracking-tight">
                  {t.title}
                </h2>
                <span className="font-mono-badge text-xs text-[var(--ink-faint)] shrink-0 tabular-nums">
                  {t.duration}
                </span>
              </div>
              <div className="flex items-end justify-between gap-4">
                <p className="font-serif-italic text-[var(--ink-muted)] flex-1">
                  {t.summary}
                </p>
                <span
                  aria-hidden
                  className="text-[var(--ink-faint)] opacity-40 group-hover:opacity-100 group-hover:text-[var(--accent)] transition-all translate-x-0 group-hover:translate-x-0.5 shrink-0"
                >
                  →
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      <p className="text-sm text-[var(--ink-faint)] italic">
        More chapters coming. If you want a specific topic next — verb tenses, word order,
        articles — let us know.
      </p>
    </main>
  );
}
